export default __webpack_public_path__ + "static/media/logo-big.cbe2bebe.jpg";